import { Component, ViewChild } from '@angular/core';

import { Footer } from '../../components/footer/footer';
import { HeroSection } from '../../components/home-components/hero-section/hero-section';
import { DiscoverSection } from '../../components/home-components/discover-section/discover-section';
import { FlexibleSection } from '../../components/home-components/flexible-section/flexible-section';
import { HowtoSection } from '../../components/home-components/howto-section/howto-section';
import { OrganizationsSection } from '../../components/home-components/organizations-section/organizations-section';
import { TestimonialSection } from '../../components/home-components/testimonial-section/testimonial-section';
import { ServicesSection } from '../../components/home-components/services-section/services-section';
import { MoreinfoSection } from '../../components/home-components/moreinfo-section/moreinfo-section';

@Component({
  selector: 'app-home',
  imports: [
    HeroSection,
    Footer,
    DiscoverSection,
    FlexibleSection,
    HowtoSection,
    OrganizationsSection,
    TestimonialSection,
    ServicesSection,
    MoreinfoSection,
  ],
  templateUrl: './home.html',
  styleUrl: './home.css',
})
export class Home {
  @ViewChild(DiscoverSection) discoverSection!: DiscoverSection;

  scrollToDiscoverTitle() {
    if (this.discoverSection) {
      this.discoverSection.scrollTitleIntoView();
    }
  }
}
